'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isUndefined(x) {
    return x === undefined;
}
exports.isUndefined = isUndefined;
